import React from 'react';
import { Icon, Typography, TypographyVariant } from '@secretescapes/falcon';
import { Attribute } from '../Attribute';
import { type ExtendedFacilitiesFact } from '../Facilities.interfaces';
import { DetailedItem, FacilityWrapper, Item } from './Facility.styles';
import { getFacilityIconName } from './Facility.utils';

export enum FacilityVariant {
  Standard = 'Standard',
  Detailed = 'Detailed',
}

interface FacilityProps {
  facility: ExtendedFacilitiesFact;
  variant?: FacilityVariant;
}

export const Facility = ({ facility, variant = FacilityVariant.Standard }: FacilityProps) => {
  const { key, groupKey, name, number, attributes } = facility;

  const facilityText = `${name} ${number && number > 1 ? `x${number}` : ''}`.trim();

  if (variant === FacilityVariant.Detailed) {
    return (
      <DetailedItem>
        <FacilityWrapper>
          <Typography variant={TypographyVariant.body}>{facilityText}</Typography>
          {attributes?.map(attribute => (
            <Attribute key={attribute?.key} attribute={attribute!} />
          ))}
        </FacilityWrapper>
      </DetailedItem>
    );
  }

  return (
    <Item>
      <Icon name={getFacilityIconName(key, groupKey ?? '')} />
      <Typography variant={TypographyVariant.body}>{facilityText}</Typography>
    </Item>
  );
};
